import {
    fetchArchiveLocations as _fetchArchiveLocations,
    createArchiveLocation as _createArchiveLocation,
    updateArchiveLocation as _updateArchiveLocation,
    deleteArchiveLocation as _deleteArchiveLocation,
} from "../../../utils/api";

export const fetchPins = (projectId, params) =>
    _fetchArchiveLocations(projectId, params);

export const createPin = (projectId, payload) =>
    _createArchiveLocation(projectId, payload);

export const updatePin = (projectId, id, payload) =>
    _updateArchiveLocation(projectId, id, payload);

export const deletePin = (projectId, id) =>
    _deleteArchiveLocation(projectId, id);
